export default __webpack_public_path__ + "static/media/tinder_header_right.44a7f478.svg";